import { render, staticRenderFns } from "./LiteratureCards.vue?vue&type=template&id=0c5bd918&"
import script from "./LiteratureCards.vue?vue&type=script&lang=js&"
export * from "./LiteratureCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports